export default __webpack_public_path__ + "alberta-save.03b230ca85ea7da63b34.svg";